module.exports = __webpack_public_path__ + "media/src/StayPackage/images/mapPin-fe0054db90d4a943e3a9b8d1c6130ac9.svg";